import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQItemm from './FAQItemm';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Destinationweddingmorachichincholi() {



    const cardData =
    {
        keyword: 'Destination Wedding Morachi Chincholi Pune',
        heading: 'Anand Krushi Paryatan Kendra: Destination Wedding Morachi Chincholi Pune',
        headingDescription: 'Dreaming of a serene countryside wedding? Anand Krushi Paryatan Kendra offers a breathtaking venue for a destination wedding Morachi Chincholi Pune, just 55 km from the city. Nestled across 40 acres of lush green farmland, this eco-friendly agri-tourism center provides the perfect blend of natural beauty and traditional village charm. Ideal for intimate or grand celebrations, the venue features open-air spaces, traditional décor, and rustic elegance—making your special day truly memorable. Guests can enjoy a complete cultural experience with bullock cart rides, folk performances, and Maharashtrian-style hospitality, alongside modern comforts and organized event support.',

        top: 'Top Activities at Anand Krushi Paryatan Kendra:',

topPlaces: [
  {
    "title": "Rustic Outdoor Wedding Venues",
    "description": "Host your dream wedding in the heart of nature with scenic farm landscapes, mango orchards, and open pavilions under the sky. Morachi Chincholi offers eco-friendly wedding lawns perfect for traditional ceremonies with a rural charm."
  },
  {
    "title": "Peacock-Themed Decor & Entry",
    "description": "Set the stage with vibrant peacock-inspired decorations—a nod to Morachi Chincholi’s pride. Couples can make a grand entrance on a bullock cart or vintage tractor, surrounded by live folk music and flower showers."
  },
  {
    "title": "Traditional Maharashtrian Catering",
    "description": "Treat guests to authentic wood-fired thalis featuring zunka-bhakar, puran poli, pithla, varan-bhat, and sweet shrikhand. Meals are served on banana leaves in an open-air dining setting, adding to the village vibe."
  },
  {
    "title": "Bullock Cart & Tractor Baraat",
    "description": "Make your wedding unforgettable with a lively baraat that uses decorated tractors or bullock carts. Live dhol, lezim performers, and peacocks in the background turn this into a festive rural parade."
  },
  {
    "title": "Open-Air Mehndi & Haldi Functions",
    "description": "Celebrate pre-wedding events like mehndi and haldi under mango trees or in bamboo gazebos, surrounded by marigold décor and folk tunes. A serene and photogenic setup for intimate moments."
  },
  {
    "title": "Onsite Stay for Guests",
    "description": "Comfortable rural cottages and dorms are available for wedding guests. These home-style stays offer cozy beds, modern bathrooms, and traditional aesthetics—keeping everyone close to the venue."
  },
  {
    "title": "Live Folk Music & Lavani Performances",
    "description": "Add a local flavor with cultural entertainment—live lavani, dholki songs, or bhajan mandals during sangeet nights. These vibrant performances create memorable, soulful evenings."
  },
  {
    "title": "Rain Dance & Poolside Celebration",
    "description": "Keep younger guests entertained with splash pools and DJ-powered rain dance zones. Ideal for a fun-filled haldi or post-wedding celebration with family and friends."
  },
  {
    "title": "Village Photoshoot Locations",
    "description": "Capture your big day with pre-wedding or post-wedding photos among sugarcane fields, flower farms, traditional mud huts, and peacocks—Morachi Chincholi offers many scenic rural backdrops."
  },
  {
    "title": "Eco-Friendly & Budget-Friendly Weddings",
    "description": "Plan a beautiful, sustainable wedding with minimal environmental impact. Packages here are cost-effective compared to city venues, with all essentials—venue, food, stay, decor, and culture—in one place."
  }
],




"services": [
  {
    "name": "Rustic Wedding Venues Near Pune",
    "description": "Anand Krushi Paryatan Kendra offers a serene, rustic wedding venue just outside Pune. With open green lawns, natural décor, and traditional elements like mud walls and thatched roofs, it’s ideal for couples seeking a charming countryside backdrop that celebrates simplicity and cultural warmth."
  },
  {
    "name": "Farm Wedding Locations Near Morachi Chincholi",
    "description": "Celebrate your big day amid mango orchards, open skies, and flowering fields. Our farm wedding venue is perfect for nature lovers looking to tie the knot in a peaceful, green, and spacious setting — far from the chaos of city venues."
  },
  {
    "name": "Outdoor Village Wedding Spaces",
    "description": "Host your wedding in a truly open-air village environment surrounded by nature. From mandap setups under mango trees to flower-adorned pathways and rural seating styles, we offer a space that feels both rooted and romantic."
  },
  {
    "name": "Budget Destination Weddings Near Pune",
    "description": "Looking for a dreamy yet affordable destination wedding? Anand Krushi Paryatan Kendra offers customizable wedding packages with venue, food, traditional décor, and basic logistics — making rural weddings a beautiful and cost-effective reality."
  },
  {
    "name": "Traditional Wedding Venue Options",
    "description": "With bullock cart entrances, dhol-tasha processions, rangoli art, and a mandap made of banana leaves and bamboo, our venue brings authentic Maharashtrian wedding traditions to life — perfect for families looking to keep rituals and culture at the center of celebrations."
  },
  {
    "name": "Wedding with Cultural Village Theme",
    "description": "Plan a one-of-a-kind cultural wedding where guests enjoy local folk music, village games, traditional meals on banana leaves, and rustic setups. This immersive experience blends rituals with rural beauty and community warmth."
  },
  {
    "name": "Wedding Lawns with Nature Backdrop",
    "description": "Our lush green wedding lawn surrounded by orchards and fields offers a natural stage for your wedding. The scenic backdrop is ideal for ceremonies, receptions, and evening events under the stars."
  },
  {
    "name": "All-Inclusive Village Wedding Packages",
    "description": "We offer complete wedding packages including décor, food, seating, lighting, sound setup, folk music, rural stay options, and basic logistics. These packages are ideal for stress-free planning while keeping the village theme intact."
  },
  {
    "name": "Intimate Farm Wedding Settings",
    "description": "Small, meaningful weddings are made memorable here. Host an intimate wedding surrounded by greenery, with handpicked décor, close family involvement, and personalized experiences — perfect for modern couples who value authenticity."
  },
  {
    "name": "Wedding with Bullock Cart Entry",
    "description": "Make a grand yet grounded entrance with a traditional bullock cart procession through the farm. It adds charm, cultural flair, and unforgettable memories to your wedding event."
  },
  {
    "name": "Haldi and Mehendi at Village Backdrop",
    "description": "Celebrate pre-wedding events like Haldi and Mehendi under mango trees, on charpais, with flower mandaps and clay décor. It brings joy, color, and tradition to life in a peaceful outdoor setting."
  },
  {
    "name": "Eco-Friendly Wedding Ideas",
    "description": "We support eco-conscious celebrations with natural décor, minimal plastic, organic food, biodegradable serving items, and reusable decoration materials — ideal for environmentally aware couples."
  },
  {
    "name": "Authentic Maharashtrian Wedding Setup",
    "description": "Our venue specializes in traditional Maharashtrian weddings, complete with Shela decoration, palkhi entry, and local culinary spreads like puran poli, aamti, and masale bhat — honoring every ritual with sincerity."
  },
  {
    "name": "Countryside Marriage Venue",
    "description": "Escape the city and say 'I do' in a picturesque countryside setting. Enjoy a blend of village life, simplicity, and celebration with farm views and earthy elegance all around."
  },
  {
    "name": "Pre-Wedding Shoot Spots in Morachi Chincholi",
    "description": "Capture magical pre-wedding moments across mango orchards, bullock carts, village lanes, and sunrise backdrops. Our farm offers multiple scenic spots for romantic and unique rural-themed photoshoots."
  }
],
"tableData": [
  ["Rustic Wedding Venues Near Pune", "- Farm Wedding Locations Near Morachi Chincholi"],
  ["Outdoor Village Wedding Spaces", "- Budget Destination Weddings Near Pune"],
  ["Traditional Wedding Venue Options", "- Wedding with Cultural Village Theme"],
  ["Wedding Lawns with Nature Backdrop", "- All-Inclusive Village Wedding Packages"],
  ["Intimate Farm Wedding Settings", "- Wedding with Bullock Cart Entry"],
  ["Haldi and Mehendi at Village Backdrop", "- Eco-Friendly Wedding Ideas"],
  ["Authentic Maharashtrian Wedding Setup", "- Countryside Marriage Venue"],
  ["Pre-Wedding Shoot Spots in Morachi Chincholi", "- "]
],



"whychoose": [
  {
    "WhyChooseheading": "Unique Rural Wedding Experience",
    "WhyChoosedescription": "Morachi Chincholi offers a one-of-a-kind setting for destination weddings with its natural landscapes, peacock-filled groves, and peaceful village ambiance. It's perfect for couples looking to tie the knot in a serene, nature-inspired atmosphere away from the city."
  },
  {
    "WhyChooseheading": "Scenic Outdoor Venues",
    "WhyChoosedescription": "From lush green farms to tamarind orchards, Morachi Chincholi provides beautiful backdrops for wedding ceremonies, receptions, and photoshoots. The open spaces allow for flexible arrangements, whether it’s a traditional mandap or a rustic outdoor setup."
  },
  {
    "WhyChooseheading": "Customizable Wedding Packages",
    "WhyChoosedescription": "Agro-tourism centers like Anand Krushi Paryatan Kendra offer tailored wedding packages that include venue decoration, catering, accommodations, and entertainment—making planning hassle-free for the couple and their families."
  },
  {
    "WhyChooseheading": "Authentic Maharashtrian Cuisine",
    "WhyChoosedescription": "Guests can indulge in traditional farm-to-table meals, including classic Maharashtrian wedding dishes like puran poli, aamras, and pithla bhakri. Freshly prepared and locally sourced food adds a rich, cultural flavor to the celebration."
  },
  {
    "WhyChooseheading": "Accommodation for Guests",
    "WhyChoosedescription": "Comfortable stay options such as cottages, tents, and dormitories are available within agro-tourism resorts. These ensure guests enjoy a cozy, nature-immersed experience during multi-day celebrations."
  },
  {
    "WhyChooseheading": "Budget-Friendly Yet Memorable",
    "WhyChoosedescription": "Compared to city-based venues, destination weddings in Morachi Chincholi are more economical while offering a truly unique, personalized, and memorable experience for the couple and their guests."
  }
]























    }

const faqData = [
  {
    id: 'FAQ1',
    question: 'Is Morachi Chincholi a good destination for weddings?',
    answer: 'Yes! Morachi Chincholi offers a unique village-themed wedding experience amidst natural surroundings, peacocks, and traditional architecture—perfect for a scenic and memorable destination wedding.',
  },
  {
    id: 'FAQ2',
    question: 'What kind of wedding venues are available?',
    answer: 'You can choose from open lawns, mandaps under trees, rustic pavilions, and covered halls provided by agro-tourism resorts like Anand Krushi Paryatan Kendra.',
  },
  {
    id: 'FAQ3',
    question: 'Can traditional Maharashtrian weddings be hosted here?',
    answer: 'Absolutely. The setting is ideal for authentic Maharashtrian rituals, with bullock cart processions, traditional music, and local décor options.',
  },
  {
    id: 'FAQ4',
    question: 'Do they offer complete wedding packages?',
    answer: 'Yes. Wedding packages typically include venue setup, catering, guest accommodation, decoration, sound systems, and event coordination.',
  },
  {
    id: 'FAQ5',
    question: 'How many guests can be accommodated?',
    answer: 'Depending on the venue, you can host intimate functions for 50–100 guests or larger gatherings with capacity for 300–500 guests in open lawn areas.',
  },
  {
    id: 'FAQ6',
    question: 'Is accommodation available for wedding guests?',
    answer: 'Yes, homestays, cottages, and dormitory-style lodging are available on-site or nearby, with options to book additional rooms in nearby farms or lodges.',
  },
  {
    id: 'FAQ7',
    question: 'What catering options are provided?',
    answer: 'Delicious traditional Maharashtrian vegetarian meals are offered, along with customizable menus to suit your wedding needs and preferences.',
  },
  {
    id: 'FAQ8',
    question: 'Can cultural entertainment be included?',
    answer: 'Yes. You can add folk dances, dhol-tasha, lavani performances, or local musicians to enhance the cultural feel of your celebration.',
  },
  {
    id: 'FAQ9',
    question: 'Is there a wedding planning team on site?',
    answer: 'Many resorts offer event coordinators who help manage logistics, decoration, catering, and guest handling from start to finish.',
  },
  {
    id: 'FAQ10',
    question: 'How far is Morachi Chincholi from Pune for guests traveling from the city?',
    answer: 'Morachi Chincholi is around 60–65 km from Pune, about 1.5 to 2 hours by road, making it a convenient and peaceful destination wedding spot.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Amol Joshi, Groom',
    feedback: "Our wedding at Morachi Chincholi was magical! The rural setting, natural beauty, and traditional décor created a truly unforgettable day for us and our families.",
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Snehal Gokhale, Bride’s Mother',
    feedback: "Hosting our daughter’s wedding at Anand Krushi Paryatan Kendra was the best decision. The staff took care of every detail, and the guests loved the village charm and hospitality.",
    rating: 5,
  },
];

























    const carouselItems = testimonials.map(testimonial => (
        <div key={testimonial.name}>
            <blockquote>

                <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
                <footer className=' user'>— {testimonial.name}</footer>
            </blockquote>
        </div>
    ));

    const carouselOptions = {
        loop: true,
        margin: 10,
        nav: true,
        items: 1
    };

    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9689125047",
            "+91 9623755047",
            "+91 9673132497",


        ],
        email: "thopatemala@gmail.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "One Day Picnic Spot Near Pune for Family",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "One Day Trip Near Pune",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Picnic Spot Near Pune ",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Picnic Destination Near Pune ",
        },
        {
            place: "/images/keyword/5.jpg",
            text: " Corporate Outing Resorts Near Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Agri Tourism Near Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Destination Wedding Near Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Hurda Party Places Near Pune",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Water Park Near Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "School Picnic Spots Near Pune for Students",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "One Day Adventure Resorts Near Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Resort Near Pune ",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Forest Resorts Near Pune ",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Nature resorts near pune for weekend",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Mango Mahotsav in Pune",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Krushi Paryatan Kendra near Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Camping Places Near Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Activities Resort Near Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Agro Tourism Near Mumbai for Family",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "One Day Picnic Spot From Mumbai",
        },
        {
            place: "/images/keyword/21.jpg",
            text: "One Day Picnic Packages Near Mumbai",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "School Picnic Spots in Mumbai",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Resort Near Mumbai ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Team Outing Places Near Mumbai",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Corporate Outing Near Mumbai",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Picnic Spot Near Nashik",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Farm House On Rent in Pune ",
        },
    ];


    const images = [
        { src: "/images/gallery/01.jpg", alt: "Image 1" },
        { src: "/images/gallery/02.jpg", alt: "Image 1" },
        { src: "/images/gallery/03.jpg", alt: "Image 1" },
        { src: "/images/gallery/04.jpg", alt: "Image 1" },
        { src: "/images/gallery/05.jpg", alt: "Image 1" },
        { src: "/images/gallery/06.jpg", alt: "Image 1" },
        { src: "/images/gallery/07.jpg", alt: "Image 1" },
        { src: "/images/gallery/08.jpg", alt: "Image 1" },
        { src: "/images/gallery/09.jpg", alt: "Image 1" },
        { src: "/images/gallery/010.jpg", alt: "Image 1" },
        { src: "/images/gallery/011.jpg", alt: "Image 1" },
        { src: "/images/gallery/012.jpg", alt: "Image 1" },

    ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Destination Wedding Morachi Chincholi Pune",
  "image": "https://morachichincholi.in/assets/images/destination-wedding-morachi-chincholi.jpg",
  "description": "Celebrate rustic and authentic destination weddings near Pune at Morachi Chincholi with farm venues, outdoor village settings, cultural themes, eco-friendly ideas, all-inclusive packages, and scenic nature backdrops.",
  "brand": {
    "@type": "Brand",
    "name": "Anand Krushi Paryatan Kendra"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "1120"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "75000",
    "availability": "https://schema.org/InStock",
    "url": "https://morachichincholi.in/destination-wedding"
  }
};



    return (
        <div>
<Helmet>
  <title>Destination Wedding Morachi Chincholi Pune | Rustic & Farm Wedding Venues</title>
  <meta 
    name="description" 
    content="Host your destination wedding near Pune at Morachi Chincholi with rustic farm venues, traditional village themes, scenic outdoor lawns, eco-friendly setups, and intimate authentic Maharashtrian celebrations." 
  />
  <meta 
    name="keywords" 
    content="Rustic wedding venues near Pune, Farm wedding locations near Morachi Chincholi, Outdoor village wedding spaces, Budget destination weddings near Pune, Traditional wedding venue options, Wedding with cultural village theme, Wedding lawns with nature backdrop, All-inclusive village wedding packages, Intimate farm wedding settings, Wedding with bullock cart entry, Haldi and mehendi at village backdrop, Eco-friendly wedding ideas, Authentic Maharashtrian wedding setup, Countryside marriage venue, Pre-wedding shoot spots in Morachi Chincholi" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section className="breadcrumb-main pb-20 pt-14" style={{ backgroundImage: 'url(images/bg/bg1.jpg)' }}>
                <div className="section-shape section-shape1 top-inherit bottom-0" style={{ backgroundImage: 'url(images/shape8.png)' }}></div>
                <div className="breadcrumb-outer">
                    <div className="container">
                        <div className="breadcrumb-content text-center">
                            <h1 className="mb-3"> {cardData.keyword}</h1>

                        </div>
                    </div>
                </div>
                <div className="dot-overlay"></div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/26.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#609F31', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 darkcolor'> Why Choose Anand Krushi Paryatan Kendra for {cardData.keyword + " Rates"}</h3>
                            {/* <BusRatesTable /> */}

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 darkcolor"> {item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">fAQS {cardData.keyword} For Anand Krushi Paryatan Kendra</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                {faqData.map((faq) => (
                                                    <FAQItemm key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <div>

                                <div className="contact-box Borderr">
                                    <h3 className='darkcolor'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Gallery</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image py-1"

                                            />
                                        </div>
                                    ))}
                                    {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #609F31',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#609F31' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2 text-white"></i>
                                            <div className=''>
                                                <a href="tel:+919689125047" className="d-block  text-white">+91 9689125047</a>
                                                <a href="tel:+919623755047" className="d-block  text-white">+91 9623755047</a>
                                                <a href="tel:+919673132497" className="d-block  text-white">+91 9673132497</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <i className="bi bi-envelope fs-1 mb-2 text-white"></i>
                                                <a href="mailto:thopatemala@gmail.com" className=" text-white d-block">
                                                    thopatemala@gmail.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <i className="bi bi-house-fill fs-1 mb-2 text-white"></i>
                                                <p className="whit text-white ">
                                                    <i> Anand Krushi Paryatan Kendra <br />
                                                        Dattatraya Anandrao Thopate, Topate Vasti, Chincholi Morachi, Tal. Shirur, Dist. Pune. Maharashtra - 412218

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Destinationweddingmorachichincholi;